/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".background[_ngcontent-%COMP%]{height:100%;background-attachment:fixed;background-position:center;background-repeat:no-repeat;background-size:cover}.logincontent[_ngcontent-%COMP%]{padding:25px;border-radius:25px;border:1px solid rgba(0,0,0,.25)}"];
export { styles as styles };
